// import { useState, useEffect } from 'react'

export function Dashboard() {
    // logic
    
    return (
        <div className="w-full h-full">
            {/* dashboard layout */}
        </div>
    )
}